<template>
  <div v-if="isdisplay" class="ptl-overlay" @click.self="masquer">
    <div class="ptl-dialog">

      <!-- Header -->
      <div class="ptl-head">
        <div class="ptl-head-left">
          <div class="ptl-head-icon"><i class="ri-smartphone-line"></i></div>
          <div class="ptl-head-txt">
            <span>Téléphone-scanner</span>
            <small>Transformez un téléphone en douchette de caisse</small>
          </div>
        </div>
        <button class="ptl-close" @click="close" aria-label="Fermer">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="ptl-body">

        <!-- Deux voyants séparés : on voit d'un coup d'œil QUI manque -->
        <div class="ptl-voyants">
          <div :class="['ptl-v', 'ptl-v-' + tonCaisse]">
            <span class="ptl-v-dot"></span>
            <span class="ptl-v-lbl"><i class="ri-computer-line"></i> Caisse</span>
            <span class="ptl-v-val">{{ texteCaisse }}</span>
          </div>
          <div :class="['ptl-v', 'ptl-v-' + tonPhone]">
            <span class="ptl-v-dot"></span>
            <span class="ptl-v-lbl"><i class="ri-smartphone-line"></i> Téléphone</span>
            <span class="ptl-v-val">{{ textePhone }}</span>
          </div>
        </div>

        <!-- Chargement -->
        <div v-if="chargement" class="ptl-vide">
          <i class="ri-loader-4-line ptl-spin"></i>
          <p>Création du lien…</p>
        </div>

        <!-- Erreur d'appairage -->
        <div v-else-if="erreur" class="ptl-err">
          <i class="ri-error-warning-line"></i>
          <span>{{ erreur }}</span>
        </div>

        <!-- QR d'appairage : masqué une fois le téléphone lié, il n'a plus d'usage -->
        <template v-else-if="!phoneConnecte">
          <div class="ptl-qr-wrap">
            <img v-if="qr" :src="qr" alt="QR d'appairage" class="ptl-qr" />
          </div>
          <p class="ptl-consigne">
            <strong>1.</strong> Ouvrez l'appareil photo du téléphone &nbsp;
            <strong>2.</strong> Visez ce QR &nbsp;
            <strong>3.</strong> Ouvrez le lien proposé
          </p>

          <details class="ptl-lien">
            <summary>Afficher le lien</summary>
            <div class="ptl-lien-row">
              <code>{{ lien }}</code>
              <button @click="copierLien"><i class="ri-file-copy-line"></i></button>
            </div>
          </details>
        </template>

        <!-- Téléphone lié : écran de travail -->
        <div v-else class="ptl-pret">
          <i class="ri-checkbox-circle-fill"></i>
          <strong>Téléphone prêt</strong>
          <p>
            Scannez le QR de commande du serveur, ou le code-barres d'un article :
            tout arrive directement sur cette caisse.
          </p>
          <span class="ptl-compteur">{{ nbrecus }} réception(s)</span>
        </div>

        <!-- Expiration -->
        <div v-if="!chargement && !erreur" class="ptl-ttl">
          <span v-if="restant > 0">
            <i class="ri-time-line"></i> Lien valable encore {{ restantTexte }}
          </span>
          <span v-else class="ptl-ttl-off">
            <i class="ri-time-line"></i> Lien expiré
          </span>
          <button class="ptl-regen" @click="appairer">
            <i class="ri-refresh-line"></i> Régénérer
          </button>
        </div>

      </div>

      <!-- Footer -->
      <div class="ptl-foot">
        <button class="ptl-btn-sec" @click="close">
          <i class="ri-link-unlink"></i> Délier
        </button>
        <button class="ptl-btn-pri" @click="masquer">
          <i class="ri-arrow-down-line"></i> Réduire
        </button>
      </div>

    </div>
  </div>
</template>

<script>
const axios = require('axios');
import qrcodetoimage from "qrcode";
import * as JwtService from "@/common/jwt.service";
import { randomString } from "@/allfunction";
import { ScangoSocket } from "@/service/scangosocket";

export default {
  /* eslint-disable */
  name: "modaltelephonelieresto",

  data() {
    return {
      isdisplay: false,
      chargement: false,
      erreur: "",
      mag: "",
      room: "",
      token: "",
      qr: "",
      lien: "",
      /* Deux voyants indépendants - voir la règle dans _connecter(). */
      etatCaisse: "connexion",  // connexion | connectee | coupure | refus
      etatPhone: "inconnu",     // inconnu | attente | connecte
      nbrecus: 0,
      restant: 0,
      timerttl: null,
    };
  },

  computed: {
    phoneConnecte() {
      return this.etatPhone === "connecte";
    },

    tonCaisse() {
      if (this.etatCaisse === "connectee") return "ok";
      if (this.etatCaisse === "coupure" || this.etatCaisse === "refus") return "ko";
      return "attente";
    },
    texteCaisse() {
      if (this.etatCaisse === "connectee") return "connectée";
      if (this.etatCaisse === "coupure") return "interrompue";
      if (this.etatCaisse === "refus") return "refusée";
      return "connexion…";
    },

    tonPhone() {
      if (this.etatPhone === "connecte") return "ok";
      if (this.etatPhone === "attente") return "attente";
      return "inconnu";
    },
    textePhone() {
      if (this.etatPhone === "connecte") return "connecté";
      if (this.etatPhone === "attente") return "en attente…";
      /* Gris, et surtout pas vert : quand la caisse est coupée, on ne SAIT plus. */
      return "inconnu";
    },

    restantTexte() {
      const m = Math.floor(this.restant / 60);
      const s = this.restant % 60;
      return m + " min " + String(s).padStart(2, "0") + " s";
    },
  },

  created() {
    /* Hors de data() : le socket n'a pas à être proxifié par Vue. */
    this.sock = new ScangoSocket();
  },

  methods: {
    _headers() {
      return {
        'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JwtService.getToken(),
        'csrftoken': this.$store.state.appsociete
      };
    },

    async appairer() {
      this.chargement = true;
      this.erreur = "";
      this.etatCaisse = "connexion";
      this.etatPhone = "inconnu";
      this.sock.deconnecter();

      const url = process.env.VUE_APP_API_URL
          + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/appairage/'
          + encodeURIComponent(this.mag || '-') + '/' + randomString();

      try {
        const res = await axios.post(url, {}, { headers: this._headers(), withCredentials: true });
        if (!res.data || !res.data.success) {
          const code = res.data && res.data.m ? res.data.m.code : "";
          this.erreur = "Appairage refusé par le serveur" + (code ? " (" + code + ")" : "") + ".";
          this.chargement = false;
          return;
        }

        this.room = res.data.m.room;
        this.token = res.data.m.token;
        this.restant = parseInt(res.data.m.ttlSeconds, 10) || 0;

        this.lien = this._construireLien(this.room, this.token);
        this.qr = await qrcodetoimage.toDataURL(this.lien, {
          errorCorrectionLevel: "M", margin: 2, width: 320,
        });

        this._connecter();
        this._demarrerTtl();
        this.chargement = false;
      } catch (e) {
        console.warn("[scango] appairage:", e);
        this.erreur = "Impossible de créer le lien. Vérifiez la connexion au serveur.";
        this.chargement = false;
      }
    },

    _construireLien(room, token) {
      /* VUE_APP_URL porte un slash final ("http://localhost:9598/"), mais rien ne
         le garantit : on normalise plutôt que d'obtenir un double slash. */
      const base = String(process.env.VUE_APP_URL || "").replace(/\/+$/, "");
      return base + "/scancaisse/" + room + "/" + token;
    },

    _connecter() {
      /* RÈGLE : l'état du téléphone nous vient du SERVEUR. Dès que la caisse perd
         sa liaison, plus aucune nouvelle n'arrive - le voyant téléphone doit donc
         retomber sur « inconnu », jamais rester sur son dernier état connu. Un
         voyant vert figé sur une liaison morte est pire que pas de voyant. */
      this.sock.connecter(
          { room: this.room, token: this.token, role: "caisse" },
          {
            onConnect: () => { this.etatCaisse = "connectee"; },
            onRefus: () => {
              this.etatCaisse = "refus";
              this._phoneInconnu();
            },
            onCoupure: () => {
              if (this.etatCaisse !== "refus") this.etatCaisse = "coupure";
              this._phoneInconnu();
            },
          }
      );

      this.sock.sur("presence", (p) => {
        /* Recevoir cet événement prouve que notre propre liaison est vivante. */
        this.etatCaisse = "connectee";
        this.etatPhone = (p && p.phone) ? "connecte" : "attente";
        /* La caisse affiche un voyant « lié » sur son FAB, y compris fenêtre réduite. */
        this.$emit('lie', this.phoneConnecte);
      });

      /* Le téléphone a scanné : on relaie tel quel à la caisse, qui décide s'il
         s'agit d'une commande serveur ou d'un article, et affiche le contrôle. */
      this.sock.sur("panier", (d) => {
        const txt = d && typeof d.txt === "string" ? d.txt : "";
        if (txt === "") return;
        this.nbrecus++;
        /* On se réduit, sans se déconnecter : le téléphone reste lié pour la
           commande suivante. C'est toute la différence avec close(). */
        this.isdisplay = false;
        this.$emit('recu', txt);
      });
    },

    /* On ne reçoit plus rien du serveur : on ne sait plus où en est le téléphone.
       Le FAB doit aussi éteindre son voyant « lié », pour la même raison. */
    _phoneInconnu() {
      this.etatPhone = "inconnu";
      this.$emit('lie', false);
    },

    _demarrerTtl() {
      this._arreterTtl();
      this.timerttl = setInterval(() => {
        if (this.restant > 0) this.restant--;
      }, 1000);
    },

    _arreterTtl() {
      if (this.timerttl) { clearInterval(this.timerttl); this.timerttl = null; }
    },

    copierLien() {
      try { navigator.clipboard.writeText(this.lien); } catch (e) { /* ignore */ }
    },

    /** Ferme la fenêtre en gardant la liaison vivante. */
    masquer() {
      this.isdisplay = false;
    },

    /** Délie vraiment : une caisse fermée ne doit pas laisser un canal ouvert. */
    close() {
      this.sock.deconnecter();
      this._arreterTtl();
      this.etatCaisse = "connexion";
      this.etatPhone = "inconnu";
      this.room = ""; this.token = ""; this.qr = ""; this.lien = "";
      this.isdisplay = false;
      this.$emit('lie', false);
    },

    /** Appelée par le parent à la fermeture de la caisse. */
    liberer() {
      this.close();
    },

    show(mag) {
      this.mag = String(mag || "");
      this.isdisplay = true;
      /* Liaison déjà vivante : on rouvre la fenêtre sans rappairer, sinon on
         couperait le téléphone du caissier à chaque consultation. */
      if (this.sock.connecte() && this.room !== "") return;
      this.appairer();
    },
  },

  beforeUnmount() {
    this.sock.deconnecter();
    this._arreterTtl();
  },

  mounted() {},
};
</script>

<style scoped>
/* ── Overlay ── */
.ptl-overlay {
  position: fixed; inset: 0; z-index: 10030;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: 'Segoe UI', system-ui, sans-serif;
}

/* ── Dialog ── */
.ptl-dialog {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 14px; width: min(430px, 100%); max-height: 92vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
  animation: ptl-in .2s cubic-bezier(.4, 0, .2, 1);
}
@keyframes ptl-in {
  from { opacity: 0; transform: scale(.93) translateY(10px); }
  to   { opacity: 1; transform: none; }
}

/* ── Header ── */
.ptl-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
}
.ptl-head-left { display: flex; align-items: center; gap: 10px; }
.ptl-head-icon {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 17px;
  display: flex; align-items: center; justify-content: center;
}
.ptl-head-txt { display: flex; flex-direction: column; line-height: 1.3; }
.ptl-head-txt span { font-size: 14px; font-weight: 800; color: var(--text); }
.ptl-head-txt small { font-size: 11px; color: var(--text2); }
.ptl-close {
  background: none; border: none; color: var(--text2); font-size: 20px;
  cursor: pointer; line-height: 1; padding: 4px; border-radius: 6px;
  transition: color .12s;
}
.ptl-close:hover { color: var(--red); }

/* ── Body ── */
.ptl-body {
  padding: 16px 18px; display: flex; flex-direction: column; gap: 12px;
  overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}

/* Voyants */
.ptl-voyants {
  display: flex; flex-direction: column; gap: 6px;
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 10px; padding: 9px 11px;
}
.ptl-v { display: flex; align-items: center; gap: 8px; font-size: 12px; }
.ptl-v-dot {
  width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0;
  background: var(--text3); transition: background .2s;
}
.ptl-v-lbl {
  display: inline-flex; align-items: center; gap: 5px;
  font-weight: 700; color: var(--text2); min-width: 96px;
}
.ptl-v-lbl i { font-size: 13px; }
.ptl-v-val { font-weight: 800; margin-left: auto; }

.ptl-v-ok .ptl-v-dot { background: var(--green); box-shadow: 0 0 0 3px color-mix(in srgb, var(--green) 22%, transparent); }
.ptl-v-ok .ptl-v-val { color: var(--green); }

.ptl-v-attente .ptl-v-dot { background: var(--amber); animation: ptl-pulse 1.1s ease-in-out infinite; }
.ptl-v-attente .ptl-v-val { color: var(--amber); }

.ptl-v-ko .ptl-v-dot { background: var(--red); }
.ptl-v-ko .ptl-v-val { color: var(--red); }

.ptl-v-inconnu .ptl-v-dot { background: var(--text3); }
.ptl-v-inconnu .ptl-v-val { color: var(--text3); }

@keyframes ptl-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: .25; }
}
.ptl-spin { display: inline-block; animation: ptl-spin .8s linear infinite; }
@keyframes ptl-spin { to { transform: rotate(360deg); } }

/* QR */
.ptl-qr-wrap {
  display: flex; align-items: center; justify-content: center;
  background: #fff; border-radius: 12px; padding: 12px;
  border: 1px solid var(--border);
}
.ptl-qr { width: 100%; max-width: 240px; height: auto; display: block; image-rendering: pixelated; }
.ptl-consigne {
  font-size: 11px; color: var(--text2); text-align: center; margin: 0; line-height: 1.6;
}
.ptl-consigne strong { color: var(--accent); }

.ptl-lien { font-size: 11px; color: var(--text2); }
.ptl-lien summary { cursor: pointer; user-select: none; }
.ptl-lien-row {
  display: flex; align-items: center; gap: 6px; margin-top: 6px;
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 7px; padding: 7px 9px;
}
.ptl-lien-row code {
  flex: 1; min-width: 0; font-size: 10px; color: var(--text3);
  overflow-wrap: anywhere; font-family: ui-monospace, 'Consolas', monospace;
}
.ptl-lien-row button {
  background: none; border: none; color: var(--text2);
  cursor: pointer; font-size: 14px; flex-shrink: 0;
}
.ptl-lien-row button:hover { color: var(--accent); }

/* Prêt */
.ptl-pret {
  display: flex; flex-direction: column; align-items: center; gap: 5px;
  text-align: center; padding: 18px 12px;
  background: color-mix(in srgb, var(--green) 8%, transparent);
  border: 1px dashed var(--green); border-radius: 12px;
}
.ptl-pret > i { font-size: 40px; color: var(--green); }
.ptl-pret strong { font-size: 14px; font-weight: 800; color: var(--text); }
.ptl-pret p { font-size: 11.5px; color: var(--text2); margin: 0; line-height: 1.5; max-width: 280px; }
.ptl-compteur {
  font-size: 10.5px; font-weight: 700; color: var(--green);
  border: 1px solid var(--green); border-radius: 5px; padding: 2px 7px; margin-top: 3px;
}

/* Divers */
.ptl-vide {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 28px; color: var(--text2);
}
.ptl-vide i { font-size: 28px; }
.ptl-vide p { font-size: 12px; margin: 0; }

.ptl-err {
  display: flex; align-items: flex-start; gap: 7px;
  background: color-mix(in srgb, var(--red) 12%, transparent);
  border: 1px solid var(--red); border-radius: 9px;
  padding: 9px 11px; color: var(--red); font-size: 11.5px; line-height: 1.45;
}
.ptl-err i { font-size: 14px; flex-shrink: 0; margin-top: 1px; }

.ptl-ttl {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  font-size: 10.5px; color: var(--text3);
  border-top: 1px dashed var(--border); padding-top: 9px;
}
.ptl-ttl-off { color: var(--red); font-weight: 700; }
.ptl-regen {
  display: inline-flex; align-items: center; gap: 4px;
  background: none; border: 1px solid var(--border); border-radius: 6px;
  padding: 4px 9px; color: var(--text2); font-size: 10.5px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.ptl-regen:hover { border-color: var(--accent); color: var(--text); }

/* ── Footer ── */
.ptl-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 14px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}
.ptl-btn-sec {
  display: flex; align-items: center; gap: 5px;
  padding: 9px 16px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.ptl-btn-sec:hover { border-color: var(--red); color: var(--red); }
.ptl-btn-pri {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 20px; border-radius: 8px; border: none;
  background: var(--accent); color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: opacity .12s;
}
.ptl-btn-pri:hover { opacity: .88; }

/* ── Mobile bottom-sheet ── */
@media (max-width: 640px) {
  .ptl-overlay { align-items: flex-end; padding: 0; }
  .ptl-dialog {
    width: 100%; border-radius: 16px 16px 0 0;
    animation: ptl-slide-up .25s cubic-bezier(.4, 0, .2, 1);
  }
}
@keyframes ptl-slide-up {
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
</style>
